import React, { useState } from "react";
import { Transition } from "@headlessui/react"; // For smooth animations

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(index === openIndex ? null : index);
  };

  const faqs = [
    {
      title: "What are the steps to obtain permanent residency in Australia?",
      content: (
        <p>
          To achieve permanent residency in Australia, you must apply for a visa
          that grants you indefinite stay rights. Common permanent residency
          visas include skilled worker visas and family-sponsored visas.
        </p>
      ),
    },
    {
      title:
        "What are the eligibility criteria for obtaining permanent residency in Australia?",
      content: (
        <p>
          To qualify for permanent residency, you need to earn at least 65
          points on the Points Test. Other criteria include being under 45 years
          of age, having a good command of the English language and choosing an
          occupation from Australia’s Skilled Occupation List.
        </p>
      ),
    },
    {
      title:
        "How long does the process take to obtain permanent residency in Australia?",
      content: (
        <p>
          The duration of the permanent residency application process varies by
          visa type. For example, Subclass 189 and 190 visas generally take
          approximately seven months, whereas Subclass 489 visas may take up to
          a year.
        </p>
      ),
    },
    {
      title:
        "What advantages come with an Australian permanent residency visa?",
      content: (
        <p>
          Permanent residency in Australia offers numerous benefits, including:
          <ul className="list-inside list-disc">
            <li>Indefinite residency in Australia.</li>
            <li>
              Full employment rights and the ability to sponsor family members.
            </li>
            <li>
              Access to Australia's public healthcare and social services.
            </li>
            <li>
              Eligibility for the First Home Owner Grant and improved credit
              opportunities.
            </li>
            <li>Education and welfare benefits for dependent children.</li>
          </ul>
        </p>
      ),
    },
    {
      title: "What is the SkillSelect program in Australia?",
      content: (
        <p>
          SkillSelect is an online system managed by the Australian government
          to help skilled workers apply for visas. To start, applicants must
          submit an Expression of Interest (EOI).
        </p>
      ),
    },
    {
      title:
        "How long do I need to reside in Australia before applying for citizenship?",
      content: (
        <p>
          To be eligible for Australian citizenship, you must have resided in
          the country for a minimum of four years, which includes one year as a
          permanent resident and the prior three years as a temporary resident
          before being granted permanent residency.
        </p>
      ),
    },
    {
      title:
        "What can I study in Australia after completing my undergraduate degree?",
      content: (
        <p>
          Completing a master’s degree in Australia can provide a significant
          boost to your professional skills and career prospects. Select a
          program that aligns with your previous studies, personal interests and
          career aspirations. Be prepared for language proficiency or aptitude
          testing during the admissions process.
        </p>
      ),
    },
    {
      title:
        "Which English language proficiency tests are accepted by Australian universities?",
      content: (
        <p>
          Australian educational institutions accept various English language
          tests, including IELTS, TOEFL, Pearson Test of English (PTE),
          Cambridge English: Advanced (CAE) and the Occupational English Test
          (OET).
        </p>
      ),
    },
    {
      title: "Are students allowed to work while studying in Australia?",
      content: (
        <p>
          Yes, international students in Australia are permitted to work during
          their studies. However, you must hold a valid student visa,
          demonstrate sufficient financial resources to cover tuition and living
          expenses and meet health and character requirements.
        </p>
      ),
    },
    {
      title: "What are the basic requirements for studying in Australia?",
      content: (
        <p>
          To study in Australia, you will need to meet the following criteria:
          <ul className="list-inside list-disc">
            <li>A valid Confirmation of Enrolment (eCoE) certificate.</li>
            <li>
              Compliance with the Genuine Temporary Entrant (GTE) requirement.
            </li>
            <li>
              Proof of financial ability to cover tuition and living costs.
            </li>
            <li>Demonstrated proficiency in the English language.</li>
            <li>Health and character checks.</li>
          </ul>
        </p>
      ),
    },
    {
      title: "What are the benefits of studying in Australia?",
      content: (
        <p>
          Studying in Australia provides numerous benefits, such as:
          <ul className="list-inside list-disc">
            <li>Globally recognized qualifications.</li>
            <li>
              Opportunities for research, scholarships and practical experience.
            </li>
            <li>Work rights during study to gain hands-on experience.</li>
            <li>
              Exposure to a multicultural environment that enhances personal and
              professional growth.
            </li>
          </ul>
        </p>
      ),
    },
    {
      title: "What makes Australia an attractive destination for investors?",
      content: (
        <p>
          Australia offers a stable political environment, a robust economic
          framework and access to rapidly expanding markets, making it an ideal
          place to invest and grow businesses.
        </p>
      ),
    },
    {
      title:
        "How can I obtain Australian permanent residency through investment?",
      content: (
        <p>
          To secure permanent residency through investment, you need to:
          <ul className="list-inside list-disc">
            <li>Meet the investment points criteria.</li>
            <li>
              Invest $1.5 million in Australian government bonds for a minimum
              of four years.
            </li>
            <li>Be under 50 years of age.</li>
            <li>
              Reside in a nominated state or territory during your investment
              period.
            </li>
          </ul>
        </p>
      ),
    },
    {
      title: "What is the work culture like in Australia?",
      content: (
        <p>
          Australia offers exciting career opportunities, particularly in fields
          like engineering, IT, healthcare and finance. Job growth is expected
          to continue, creating a high demand for skilled workers across various
          industries.
        </p>
      ),
    },
    {
      title: "What types of visas are available for Australia?",
      content: (
        <p>
          Australia provides a wide range of visa options, including:
          <ul className="list-inside list-disc">
            <li>Skilled Independent Visa (subclass 189).</li>
            <li>Skilled Nominated Visa (subclass 190).</li>
            <li>Temporary Graduate Visa (subclass 485).</li>
          </ul>
        </p>
      ),
    },
    {
      title: "Can I bring my family with me on a student visa to Australia?",
      content: (
        <p>
          Yes, most student visa categories allow you to bring dependents such
          as your spouse and children. You must show that you have enough
          financial resources to support them during their stay in Australia.
        </p>
      ),
    },
    // Add other FAQ items as needed...
  ];
  const [isOpen, setIsOpen] = useState(false);

  const toggleAnswer = () => {
    setIsOpen(!isOpen);
  };
  return (
    <div>
      {/* Section: Why Choose Australia */}
      <div className="flex w-full flex-col items-center justify-center py-20">
        {isOpen && (
          <div className="mb-6 w-3/4 items-center justify-center rounded-md text-black bg-gray-100 p-4 text-lg shadow-md">
            <p>
              <br />
              - What makes Australia unique? Known as the 'Island Continent,'
              Australia offers unmatched opportunities, cultural diversity and a
              high quality of life.
              <br />
              - How is Australia’s economy? Australia boasts one of the
              strongest economies, with consistent growth for over 28 years,
              offering excellent career prospects for skilled migrants.
              <br />
              - What’s special about Australia’s climate and nature? Experience
              a pleasant climate, iconic World Heritage sites like the Great
              Barrier Reef and unique biodiversity with flora and fauna found
              nowhere else.
              <br />
              - Why is Australia ideal for education? Australia is the third
              most preferred destination for international students, offering
              top-notch education and a welcoming environment.
              <br />
              Embark on your journey to Australia and explore endless
              opportunities with Visa World!
            </p>
          </div>
        )}
        <button
          onClick={toggleAnswer}
          className="w-2/2 flex items-center justify-center rounded-full bg-blue-600 px-6 py-3 text-center text-md font-semibold text-white transition duration-300 ease-in-out hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 md:w-1/2"
        >
          Why Choose Australia?
          <svg
            className={`ml-3 h-4 w-4 transform transition-transform duration-300 ${
              isOpen ? "rotate-180" : ""
            }`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M12 5v14M5 12l7 7 7-7"></path>
          </svg>
        </button>
      </div>

      <div className="mx-auto max-w-5xl rounded-lg bg-white p-6">
        <h2 className="mb-4 text-center text-4xl font-semibold text-[#011473]">
          FAQ's
        </h2>
      </div>

      <div className="mx-auto max-w-5xl p-6">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="mb-4 overflow-hidden rounded-lg border shadow-sm"
          >
            <button
              className={`flex w-full items-center justify-between px-4 py-3 text-left font-semibold ${
                openIndex === index ? "bg-blue-600 text-white" : "bg-gray-100"
              }`}
              onClick={() => toggleFAQ(index)}
            >
              {faq.title}
              <span
                className={`transform transition-transform ${
                  openIndex === index ? "rotate-180" : "rotate-0"
                }`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  className="h-5 w-5"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
            </button>
            <Transition
              show={openIndex === index}
              enter="transition-all duration-200 ease-out"
              enterFrom="max-h-0 opacity-0"
              enterTo="max-h-96 opacity-100"
              leave="transition-all duration-200 ease-in"
              leaveFrom="max-h-96 opacity-100"
              leaveTo="max-h-0 opacity-0"
            >
              <div className="bg-white px-4 py-3 text-gray-700">
                {faq.content}
              </div>
            </Transition>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
